<div class="license-list">
  @for (license of licenses; track license) {
    <bmcore-license-item
      [license]="license"
      [licenseBulkDiscounts]="licenseBulkDiscounts"
      [btnInLicenseName]="btnInLicenseName"
      [toBeatListBtnRoute]="toBeatListBtnRoute"
    >
    </bmcore-license-item>
  }
</div>
